import { createFileRoute } from '@tanstack/react-router';
import { AgreementDetailPage } from '@/pages/member-portal/agreements/AgreementDetailPage';

function MemberPortalAgreementDetailRoute() {
	return <AgreementDetailPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/agreements/$id')({
	component: MemberPortalAgreementDetailRoute,
});
